var graph_container = $("#lcfs_graph_container")
if (graph_container.length > 0) {
  $.getJSON(graph_container.data("url"), function(data) {
    if (data.hours && data.hourly_kwh.length > 0) {
      var ctx = $("#myChart")
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: data.hours,
          datasets: [
            {
              label: "total kWh per hour of day dispensed",
              data: data.hourly_kwh,
              barThickness: 30,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          scales: {
            xAxes: {
              gridLines: {
                offset: false
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: "rgba(251, 232, 170, .8)",
            xPadding: 16,
            yPadding: 16,
            titleFontSize: 16,
            titleFontColor: "#3598db",
            bodyFontColor: "black",
            bodyFontSize: 14,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              title: function(tooltipItem, data) {
                return data["labels"][tooltipItem[0]["index"]]
              },
              label: function(tooltipItem, data) {
                return data["datasets"][0]["data"][tooltipItem["index"]] + " kWh by hour"
              }
            }
          }
        }
      })

      return $("#chartAreaWrapper").css("width", "800px")
    } else {
      return $("#myChart").hide()
    }
  })
}
